function recherche(page)
{
	document.requete.page.value=page;
	document.requete.submit();
}